import { Box, CardProps, Container } from '@chakra-ui/react';

export interface PageCardProps extends CardProps {}

export const PageCard = (props: React.PropsWithChildren<PageCardProps>) => {
  const { children, ...other } = props;

  return (
    <Box
      as="section"
      bg="bg-surface"
      pt={{ base: 4, md: 8 }}
      pb={{ base: 4, md: 8 }}
      borderRadius={'lg'}
      boxShadow={'2xl'}
      {...other}
    >
      <Container>{children}</Container>
    </Box>
  );
};
